import { Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Iniciales: si hay 4 palabras, omite la del segundo nombre */
const getInitials = (fullName) => {
  if (!fullName) return '?';
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 4) {
    return (parts[0][0] + parts[2][0] + parts[3][0]).toUpperCase();
  }
  return parts.map(w => w[0].toUpperCase()).join('');
};

const StyledAvatar = styled(Avatar, {
  // Evita que 'size' y 'color' se pasen al DOM / Avatar (no son props válidas ahí)
  shouldForwardProp: (prop) => !['size', 'color'].includes(prop),
})(({ theme, size = 'medium', color = 'secondary' }) => {
  const sizeMap = {
    small:       { width: 32,  height: 32,  fontSize: '0.875rem' },
    medium:      { width: 40,  height: 40,  fontSize: '1rem'     },
    large:       { width: 48,  height: 48,  fontSize: '1.25rem'  },
    xlarge:      { width: 120, height: 120, fontSize: '3rem'     },
    'card-small':  { width: 48, height: 48, fontSize: '1rem'     },
    'card-medium': { width: 56, height: 56, fontSize: '1.2rem'   },
    'card-large':  { width: 64, height: 64, fontSize: '1.5rem'   },
  };

  // Toma el color desde el theme (primary, secondary, etc.)
  const pal = theme.palette[color] || theme.palette.secondary;

  return {
    ...sizeMap[size],
    backgroundColor: pal.main,        // <- usar backgroundColor (no bgcolor)
    color: pal.contrastText,
    fontWeight: 700,
    lineHeight: 1,
    userSelect: 'none',
    transition: 'transform 0.2s',
    '&:hover': { transform: 'scale(1.05)' },
  };
});

export const UserAvatar = ({ name, size = 'medium', color = 'secondary', ...props }) => {
  return (
    <StyledAvatar size={size} color={color} {...props}>
      {getInitials(name)}
    </StyledAvatar>
  );
};
